var map = {
	"./en.json": 75553,
	"./es.json": 72706,
	"./ilo.json": 20340,
	"./ja.json": 42551,
	"./ko.json": 18976,
	"./tl.json": 37674,
	"./vi.json": 21779,
	"./zh.json": 44028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49401;